module.exports = __webpack_public_path__ + "static/media/como-5.fd669431.jpg";